import { createSlice } from '@reduxjs/toolkit'
import { PUBLIC_TYPE } from 'utils/consts'
import type { OfferCreateState } from './types'

const initialState: OfferCreateState = {
  pricePer: '',
  buyerCategory: null,
  buyerCompany: null,
  sellerCompany: null,
  validityPeriod: null,
  incoterms: null,
  warehouse: null,
  products: {},
  offerType: PUBLIC_TYPE,
  creationType: null,
  errors: {},
  contactEmail: null,
  contactPhone: null,
  copyMode: false,
  availableRoutes: ['/acc/sell-wine/my-offers/add-offer/wine'],
  loading: false,
  note: null,
  tabsCache: {},
  validationAttempt: 0,
}

const updateCache = (state: OfferCreateState) => {
  if (state.creationType) {
    state.tabsCache[state.creationType] = { ...state.products }
  }
}

const offerCreateSlice = createSlice({
  name: 'offerCreate',
  initialState,
  reducers: {
    setData: (state, { payload }) => {
      return { ...state, ...payload }
    },
    setProducts: (state, { payload }) => {
      state.products = payload
      updateCache(state)
    },
    appendProducts: (state, { payload }) => {
      state.products = { ...state.products, ...payload }
      if (state.errors?.noProducts) {
        const errors = state.errors
        state.errors = { ...errors, noProducts: null }
      }
      updateCache(state)
    },
    addProduct: (state, { payload }) => {
      state.products = { ...state.products, [payload.id]: payload.data }
      updateCache(state)
    },
    removeProduct: (state, { payload }) => {
      const value = { ...state.products }
      delete value[payload]
      state.products = value
      updateCache(state)
    },
    setProductField: (state, { payload }) => {
      state.products = {
        ...state.products,
        [payload.id]: {
          ...state.products[payload.id],
          [payload.field]: payload.data,
        },
      }
      updateCache(state)
    },
    setField: (state, { payload }) => {
      state[payload.field] = payload.data
    },
    setFieldError: (state, { payload }) => {
      state.errors = {
        ...state.errors,
        [payload.id]: {
          ...state.errors[payload.id],
          [payload.field]: payload.data,
        },
      }
    },
    setError: (state, { payload }) => {
      state.errors = {
        ...state.errors,
        [payload.field]: payload.data,
      }
    },
    setPricePer: (state, { payload }) => {
      state.pricePer = payload
    },
    setCreationType: (
      state,
      { payload }: { payload: 'image' | 'search' | null }
    ) => {
      state.creationType = payload
      if (payload && state.tabsCache[payload]) {
        state.products = { ...state.tabsCache[payload] }
      }
    },
    seCopyMode: state => {
      state.copyMode = true
    },
    reset: () => {
      return initialState
    },
  },
})

export const { actions, reducer: offerCreate } = offerCreateSlice
export const {
  setData,
  setProducts,
  appendProducts,
  addProduct,
  removeProduct,
  setProductField,
  setField,
  setFieldError,
  setError,
  setPricePer,
  setCreationType,
  seCopyMode,
  reset,
} = actions
